import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "projetos" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Novo projeto", -1)
const _hoisted_4 = { class: "table is-fullwidth" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Nome"),
    /*#__PURE__*/_createElementVNode("th", null, "Ações")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" })
], -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" })
], -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/projetos/novo",
      class: "button"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("table", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projetos, (projeto) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: projeto.id
          }, [
            _createElementVNode("td", null, _toDisplayString(projeto.id), 1),
            _createElementVNode("td", null, _toDisplayString(projeto.nome), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_router_link, {
                to: `/projetos/${projeto.id}`,
                class: "button"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("button", {
                class: "button ml-2 is-danger",
                onClick: ($event: any) => (_ctx.excluir(projeto.id))
              }, _hoisted_9, 8, _hoisted_7)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}